import { Box, Typography } from '@material-ui/core';

import type { OptionListProps } from '../option_list/OptionList';
import { OptionList } from '../option_list/OptionList';

/** `OptionList` with styles used within a `StepContainer`. */
export function StepOptionList<T>(props: OptionListProps<T>): JSX.Element {
  return (
    <Box maxWidth="328px" mx="auto">
      <OptionList {...props} />
    </Box>
  );
}
